var cov_rxs2z2k5u = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/required.ts",
      hash = "787376157e65f55b60eb58ca0674e6472aaf04de",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/required.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 66
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 32
        },
        end: {
          line: 2,
          column: 39
        }
      },
      "2": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "3": {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 18
        }
      },
      "4": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 10
        }
      },
      "5": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "6": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 32
        }
      },
      "7": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 10
        }
      },
      "8": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 66
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 1,
            column: 66
          },
          end: {
            line: 1,
            column: 67
          }
        },
        loc: {
          start: {
            line: 1,
            column: 137
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 7,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 7,
            column: 19
          }
        }, {
          start: {
            line: 7,
            column: 23
          },
          end: {
            line: 7,
            column: 41
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default (function (options) {
  cov_rxs2z2k5u.f[0]++;
  cov_rxs2z2k5u.s[0]++;
  return function (value, _formdata, callback) {
    cov_rxs2z2k5u.f[1]++;

    var _ref = (cov_rxs2z2k5u.s[1]++, options),
        message = _ref.message,
        required = _ref.required;

    cov_rxs2z2k5u.s[2]++;

    if (required === false) {
      cov_rxs2z2k5u.b[0][0]++;
      cov_rxs2z2k5u.s[3]++;
      callback(true);
      cov_rxs2z2k5u.s[4]++;
      return;
    } else {
      cov_rxs2z2k5u.b[0][1]++;
    }

    cov_rxs2z2k5u.s[5]++;

    if ((cov_rxs2z2k5u.b[2][0]++, value == null) || (cov_rxs2z2k5u.b[2][1]++, value.length === 0)) {
      cov_rxs2z2k5u.b[1][0]++;
      cov_rxs2z2k5u.s[6]++;
      callback(new Error(message));
      cov_rxs2z2k5u.s[7]++;
      return;
    } else {
      cov_rxs2z2k5u.b[1][1]++;
      cov_rxs2z2k5u.s[8]++;
      callback(true);
    }
  };
});